export class SelectedProvider {
    providerName: string | undefined;
    addresses: string[] | undefined;
    programs: string[] | undefined;
    constructor(options?: Partial<SelectedProvider>) {
        Object.assign(this, options);
    }
}
